import { PageImput } from './Components/PageImput'
import  {Footer}  from './Components/Footer'

function App() {
  return (
    <div className="App">
      <PageImput />
      <Footer />

    </div>
  );
}

export default App;
